import React, { useState, useEffect } from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import { getFullName } from "utils/displayName";
import moment from "moment";
import JSONPretty from "react-json-pretty";
import { Loader, Comment, Header } from "semantic-ui-react";
import { isJson } from "utils/json";
import "react-vertical-timeline-component/style.min.css";
import "styles/timeline.css";

const LogTimelineBusiness = ({ logs }) => {
	const [resultLogs, setResultLogs] = useState([]);
	const checkCreationFolder = (logs) => {
		let result = [];
		if (logs.list.length > 0 && logs.list.some((log) => log.entity === "Folder" && log.action === "CREATE")) {
			let logCreation = logs.list.find((log) => log.entity === "Folder" && log.action === "CREATE");
			let preregister =
				isJson(logCreation.new_value) &&
				JSON.parse(logCreation.new_value).hasOwnProperty("preregister") &&
				JSON.parse(logCreation.new_value).preregister !== null;

			let r = {
				action: preregister ? "Création d'une pré-inscription" : "Création du dossier",
				by: logCreation.user,
				date: logCreation.created_at,
				patient: isJson(logCreation.new_value) ? getFullName(JSON.parse(logCreation.new_value).patient) : "",
			};
			if (
				logs.list.some(
					(log) =>
						log.entity === "FolderHelp" && log.action === "CREATE" && log.created_at.substring(0, 16) === logCreation.created_at.substring(0, 16)
				)
			) {
				result.action += " et envoi au télésecrétariat";
			}

			if (
				logs.list.some(
					(log) => log.entity === "Folder" && log.action === "UPDATE" && log.created_at.substring(0, 16) === logCreation.created_at.substring(0, 16)
				)
			) {
				let logOpening = logs.list.find(
					(log) => log.entity === "Folder" && log.action === "UPDATE" && log.created_at.substring(0, 16) === logCreation.created_at.substring(0, 16)
				);
				let newValue = JSON.parse(logOpening.new_value);
				if (newValue.hasOwnProperty("openedBy") && newValue.openedBy !== null && newValue.openedBy.id === logCreation.user_id) {
					result.action += " et ouverture";
				}
			}
			result.push(r);
		}
		return result;
	};

	const checkCreationPrescription = (logs) => {
		let result = [];
		if (logs.list.length > 0 && logs.list.some((log) => log.entity === "Prescription" && log.action === "CREATE")) {
			let logCreation = logs.list.find((log) => log.entity === "Prescription" && log.action === "CREATE");
			let r = { action: "Création d'une prescription", by: logCreation.user, date: logCreation.created_at };

			let newValue = JSON.parse(logCreation.new_value);
			if (newValue.hasOwnProperty("prescriber") && newValue.prescriber !== null) {
				r.prescriber = `${newValue.prescriber.title} ${newValue.prescriber.last_name} ${newValue.prescriber.first_name}`;
			}
			if (newValue.hasOwnProperty("issue_date") && newValue.issue_date !== null) {
				r.issue_date = newValue.issue_date;
			}
			result.push(r);
		}
		return result;
	};
	const checkAnalyses = (logs) => {
		let result = [];
		if (logs.list.length > 0 && logs.list.some((log) => log.entity === "Analysis" && log.action === "CREATE")) {
			let logCreations = logs.list.filter((log) => log.entity === "Analysis" && log.action === "CREATE");
			let dates = logCreations.map((l) => l.created_at.substring(0, 16)).filter((value, index, array) => array.indexOf(value) === index);
			dates.forEach((date) => {
				let analyses = logCreations.filter((l) => l.created_at.substring(0, 16) === date).map((log) => JSON.parse(log.new_value).properties.code);
				if (analyses.length > 0)
					result.push({
						action: "Ajout d'analyse(s)",
						by: logCreations[0].user,
						date: logCreations.find((l) => l.created_at.substring(0, 16) === date).created_at,
						analyses: analyses.join(", "),
					});
			});
		}
		return result;
	};
	const checkBarcode = (logs) => {
		let result = [];
		if (
			logs.list.length > 0 &&
			logs.list.some((log) => log.entity === "PrescriptionScan" && log.action === "CREATE" && JSON.parse(log.new_value).barcode !== "")
		) {
			let logCreations = logs.list.filter(
				(log) => log.entity === "PrescriptionScan" && log.action === "CREATE" && JSON.parse(log.new_value).barcode !== ""
			);
			logCreations.forEach((element) => {
				result.push({
					action: "Ajout d'un code-barre ordo",
					by: element.user,
					date: element.created_at,
					barcode: JSON.parse(element.new_value).barcode,
				});
			});
		}
		return result;
	};
	const checkAlerteGeslab = (logs) => {
		let result = [];
		if (
			logs.list.length > 0 &&
			logs.list.some(
				(log) =>
					log.entity === "Folder" &&
					log.action === "UPDATE" &&
					isJson(log.new_value) &&
					JSON.parse(log.new_value).hasOwnProperty("geslab_alert") &&
					JSON.parse(log.new_value).geslab_alert !== ""
			)
		) {
			let logCreations = logs.list.filter(
				(log) =>
					log.entity === "Folder" &&
					log.action === "UPDATE" &&
					isJson(log.new_value) &&
					JSON.parse(log.new_value).hasOwnProperty("geslab_alert") &&
					JSON.parse(log.new_value).geslab_alert !== ""
			);
			logCreations.forEach((element) => {
				result.push({
					action: "Alerte Geslab",
					by: element.user,
					date: element.created_at,
					geslab_alert: JSON.parse(element.new_value).geslab_alert_comment,
				});
			});
		}
		return result;
	};

	const checkOpeningFolder = (logs) => {
		let result = [];
		if (
			logs.list.length > 0 &&
			logs.list.some(
				(log) => log.entity === "Folder" && log.action === "UPDATE" && isJson(log.new_value) && JSON.parse(log.new_value).hasOwnProperty("openedBy")
			)
		) {
			let logCreations = logs.list.filter(
				(log) => log.entity === "Folder" && log.action === "UPDATE" && JSON.parse(log.new_value).hasOwnProperty("openedBy")
			);

			logCreations.forEach((element) => {
				if (isJson(element.new_value) && JSON.parse(element.new_value).openedBy !== null)
					result.push({
						action: "Ouverture du dossier",
						by: element.user,
						date: element.created_at,
					});
				else
					result.push({
						action: "Fermeture du dossier",
						by: element.user,
						date: element.created_at,
					});
			});
		}
		return result;
	};

	useEffect(() => {
		setResultLogs([]);
		let folder = checkCreationFolder(logs);
		let prescription = checkCreationPrescription(logs);
		let analyses = checkAnalyses(logs);
		let barcode = checkBarcode(logs);
		let alertsGeslab = checkAlerteGeslab(logs);
		let openingFolder = checkOpeningFolder(logs);
		if (folder) {
			setResultLogs(
				resultLogs
					.concat(folder)
					.concat(prescription)
					.concat(analyses)
					.concat(barcode)
					.concat(alertsGeslab)
					.concat(openingFolder)
					.sort((a, b) => (a.date > b.date ? 1 : -1))
			);
		}
	}, [logs]);

	return (
		<div>
			{logs.list.length > 0 && (
				<Comment.Group size="small">
					<Header as="h3" dividing>
						Informations du parcours pour ce dossier
					</Header>
					{resultLogs.map((log, index) => (
						<Comment key={`log-${index}`}>
							<Comment.Avatar src="https://react.semantic-ui.com/images/avatar/small/matt.jpg" />
							<Comment.Content>
								<Comment.Author>{log.action}</Comment.Author>
								{(log.prescriber || log.patient || log.analyses || log.barcode || log.issue_date || log.geslab_alert) && (
									<Comment.Metadata>
										{log.prescriber && <Comment.Metadata>Prescripteur : {log.prescriber}</Comment.Metadata>}
										{log.patient && <Comment.Metadata>Patient : {log.patient}</Comment.Metadata>}
										{log.analyses && <Comment.Metadata>Analyse(s) : {log.analyses}</Comment.Metadata>}
										{log.barcode && <Comment.Metadata>Code-barre : {log.barcode}</Comment.Metadata>}
										{log.issue_date && (
											<Comment.Metadata>
												Date de délivrance : {moment(log.issue_date).format(`${process.env.REACT_APP_DATE_DISPLAY_FORMAT}`)}
											</Comment.Metadata>
										)}
										{log.geslab_alert && <Comment.Metadata>Alerte Geslab : {log.geslab_alert}</Comment.Metadata>}
									</Comment.Metadata>
								)}
								<Comment.Text>
									Par {log.by} - <span>{moment(log.date).format(`${process.env.REACT_APP_DATE_DISPLAY_FORMAT}, HH:mm:ss`)}</span>
								</Comment.Text>
							</Comment.Content>
						</Comment>
					))}
				</Comment.Group>
			)}

			{logs.list.length === 0 && !logs.loading && (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<span>Aucun log</span>
				</div>
			)}

			{logs.loading && (
				<div style={{ margin: "20px 0" }}>
					<Loader active />
				</div>
			)}
		</div>
	);
};

const styles = {
	center: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	verticalCenter: {
		display: "flex",
		alignItems: "center",
	},
};

export default LogTimelineBusiness;
